<template lang="pug">
#oddsType.modal.modal-bottom.fade.modal-common(tabindex='-1' role='dialog' aria-labelledby='oddsType' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.modal-bottom-center(role='document')
    .modal-content
      .modal-header
        .icon(data-bs-dismiss='modal' aria-label='Close')
          i.fas.fa-arrow-left
        h5.modal-title {{ $t("ui.odds_type") }}
      .modal-body
        ul.list-group.setting
          template(v-for="(value, key) in oddsTypeList")
            li.list-group-item(:class="{ active : oddsType == key }" @click="setOddsType(key)")
              span {{ $tc(value, 2) }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";

export default {
  data: () => ({
    oddsTypeList: {
      MY: "ui.my_odds",
      HK: "ui.hk_odds",
      ID: "ui.id_odds",
      DEC: "ui.dec_odds"
    }
  }),
  computed: {
    oddsType() {
      return this.$store.state.layout.pageDisplay.oddsType;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    order() {
      return this.$store.state.layout.order.sports;
    },
  },
  methods: {
    setOddsType(s) {
      this.$store
        .dispatch("user/setSettings", {
          page_display: JSON.stringify({
            language: this.pageDisplay.language,
            oddsType: this.pageDisplay.oddsType,
            pageType: this.pageDisplay.pageType,
            showScoreMap: this.pageDisplay.showScoreMap,
            eventSorting: this.pageDisplay.eventSorting,
            marketType: this.pageDisplay.marketType,
            pageSize: this.pageDisplay.pageSize,
            mmoType: this.pageDisplay.mmoType,
          }),
          sports_order: JSON.stringify(this.order),
          betting: JSON.stringify({
            defaultStake: this.betting.defaultStake,
            acceptBetterOdds: this.betting.acceptBetterOdds,
            acceptAnyOdds: this.betting.acceptAnyOdds,
            autoRefreshOdds: this.betting.autoRefreshOdds,
            quickBet: this.betting.quickBet,
            defaultStakeAmount: this.betting.defaultStakeAmount,
            quickBetAmount: this.betting.quickBetAmount,
          }),
        })
        .then(
          (res) => {
            this.$store.dispatch("layout/setSinglePageDisplay", { property: "oddsType", value: s }).then(
              (res) => {
                this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.succeed"), "success");
              },
              (err) => {
                this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
              }
            );
            EventBus.$emit("ODDS_TYPE");
            $("#oddsType").modal("hide");
          },
          (err) => {
            this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
            EventBus.$emit("ODDS_TYPE");
            $("#oddsType").modal("hide");
          }
        );
    }
  }
};
</script>
